import { CommonModule } from '@angular/common';
import {
  Component,
  Output,
  EventEmitter,
  input,
  inject,
  effect,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  WarehouseListModel,
  WarehouseModel,
  LocationModel,
} from '@kanzi-apes/kanzi-models';
import { KanziPrimeUiModule } from '@kanzi-apes/kanzi-prime-ui';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'kanzi-warehouse-root-selector',
    imports: [CommonModule, KanziPrimeUiModule, FormsModule, TranslateModule],
    templateUrl: './kanzi-ui-warehouse-root-selector.component.html',
    styleUrls: ['./kanzi-ui-warehouse-root-selector.component.scss'],
    animations: []
})
export class KanziUIWarehouseRootSelectorComponent {
  warehouseRFIDMode = input<boolean>(false);
  placeholderSelector = input<string>('Seleccionar');
  warehouseRootsSelected = input<WarehouseModel | null>();
  warehouseList = input<WarehouseListModel | null>();
  warehouseRFIDList = input<LocationModel[] | null>();
  warehouseRFIDRootsSelected = input<LocationModel | null>();
  warehouseRootsSelectedForm: WarehouseModel | LocationModel | null = null;
  warehouseOptions: WarehouseModel[] | LocationModel[] = [];

  @Output() selectWarehouseRoot: EventEmitter<WarehouseModel> =
    new EventEmitter();
  @Output() selectWarehouseRFIDRoot: EventEmitter<LocationModel> =
    new EventEmitter();

  translateService = inject(TranslateService);

  warehouseRFIDListEffect = effect(() => {
    const warehouseRFIDList = this.warehouseRFIDList();
    if (warehouseRFIDList) {
      this.warehouseOptions = warehouseRFIDList;
    }
  });

  warehouseListEffect = effect(() => {
    const warehouseList = this.warehouseList();
    if (warehouseList) {
      this.warehouseOptions = warehouseList.results;
    }
  });

  constructor() {
    effect(() => {
      const warehouseRootSelected = this.warehouseRootsSelected();
      if (warehouseRootSelected) {
        this.warehouseRootsSelectedForm = warehouseRootSelected;
      }
      const warehouseRFIDRootSelected = this.warehouseRFIDRootsSelected();
      if (warehouseRFIDRootSelected) {
        this.warehouseRootsSelectedForm = warehouseRFIDRootSelected;
      }
    });
  }
  onSelectWarehouse(warehouseRoot: any) {
    const warehouseRootsSelected = this.warehouseRootsSelected();
    if (!this.warehouseRFIDMode()) {
      if (
        warehouseRootsSelected &&
        warehouseRootsSelected.id !== warehouseRoot.id
      ) {
        this.selectWarehouseRoot.emit(warehouseRoot.value);
      } else if (!warehouseRootsSelected) {
        this.selectWarehouseRoot.emit(warehouseRoot.value);
      }
    } else {
      if (
        this.warehouseRFIDRootsSelected() &&
        this.warehouseRFIDRootsSelected()?.id !== warehouseRoot.value.id
      ) {
        this.selectWarehouseRFIDRoot.emit(warehouseRoot.value);
      } else if (!this.warehouseRFIDRootsSelected()) {
        this.selectWarehouseRFIDRoot.emit(warehouseRoot.value);
      }
    }
  }
}
